import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { PaymentHealth } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/payment-health")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <PaymentHealth />
    </RouteGuard>
  ),
});
